import { useSearchPageState } from '@klareospace/pharos-lib-front-utils';
import type { HandlingUnitType } from '@klareospace/pharos-lib-types';

import { useHandlingUnitTypes } from './use-handling-unit-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseHandlingUnitTypesPageReturn {
  currentPage: number;
  error: Error | null;
  handlingUnitTypes: HandlingUnitType[];
  isLoading: boolean;
  onPageChange: (newPage: number) => void;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useHandlingUnitTypesPage(): UseHandlingUnitTypesPageReturn {
  const searchState = useSearchPageState();

  const { data, error, isLoading } = useHandlingUnitTypes({
    page: searchState.currentPage,
    pageSize: searchState.pageSize,
    statuses: ['active'],
  });

  return {
    currentPage: searchState.currentPage,
    error: error ?? null,
    handlingUnitTypes: data?.items ?? [],
    isLoading,
    onPageChange: searchState.onPageChange,
    pageSize: searchState.pageSize,
    totalItems: data?.total ?? 0,
    totalPages: data?.totalPages ?? 1,
  };
}
